import type { State } from '../../typings'
import { initialState } from '../../initState'

export const deleteActivityProducer = (
  state: State,
  payload: number,
): State => {
  const activities = state.activities.filter(
    (activity) => activity.id !== payload,
  )

  return {
    ...initialState,
    filters: state.filters,
    history: state.history,
    filtersChecksum: state.filtersChecksum,
    activities,
  }
}
